'use client';

import { useState } from 'react';

import { MinusIcon, PlusIcon } from 'lucide-react';

import { trackFaqExpanded } from '~/lib/analytics/posthog-events';

import {
  type SpitexFaqItem,
  demandFaqItems,
  supplyFaqItems,
} from './spitex-faq-data';

function FaqItemRow({
  item,
  verticalSlug,
}: {
  item: SpitexFaqItem;
  verticalSlug: string;
}) {
  const [open, setOpen] = useState(false);

  return (
    <div className="border-border border-b">
      <button
        type="button"
        className="flex w-full items-center justify-between gap-4 py-5 text-left"
        onClick={() => {
          if (!open) {
            trackFaqExpanded(item.question, verticalSlug);
          }

          setOpen(!open);
        }}
        aria-expanded={open}
      >
        <h3 className="text-foreground text-lg font-medium">{item.question}</h3>
        <span className="text-muted-foreground flex h-8 w-8 shrink-0 items-center justify-center">
          {open ? (
            <MinusIcon className="h-5 w-5" />
          ) : (
            <PlusIcon className="h-5 w-5" />
          )}
        </span>
      </button>
      {open && (
        <div className="pb-5">
          <p className="text-muted-foreground text-base leading-relaxed">
            {item.answer}
          </p>
        </div>
      )}
    </div>
  );
}

interface SpitexFaqProps {
  side: 'supply' | 'demand';
  verticalSlug: string;
}

export function SpitexFaq({ side, verticalSlug }: SpitexFaqProps) {
  const faqs = side === 'supply' ? supplyFaqItems : demandFaqItems;
  const title =
    side === 'supply' ? 'Haeufige Fragen' : 'Haeufige Fragen zur Spitex';

  return (
    <section className="bg-background w-full px-4 py-16 sm:py-20">
      <div className="mx-auto max-w-6xl">
        <h2 className="text-muted-foreground mb-12 text-center text-sm tracking-[0.2em] uppercase">
          {title}
        </h2>

        <div className="mx-auto max-w-3xl">
          {faqs.map((faq) => (
            <FaqItemRow
              key={faq.question}
              item={faq}
              verticalSlug={verticalSlug}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
